// faviconBadgePick.js
// Pure selection logic for the single browser-tab favicon badge slot.
// Priority: red unread (inbox, then support) wins; the blue open-tickets count
// only surfaces when there is no red unread. Kept DOM-free so it is unit-testable.

export const FAVICON_COLORS = {
    red: '#dc3545',   // Bootstrap danger (unread messages / tickets)
    blue: '#0d6efd',  // Bootstrap primary (open support tickets)
};

// Order encodes priority — the first source with count > 0 wins the slot.
export const FAVICON_PRIORITY = ['inbox', 'support', 'supportOpen'];

const SOURCE_COLOR = {
    inbox: FAVICON_COLORS.red,
    support: FAVICON_COLORS.red,
    supportOpen: FAVICON_COLORS.blue,
};

// sources: { inbox, support, supportOpen } (numbers). Returns the winning
// { count, color }, or { count: 0, color: null } when every source is zero.
export const pickBadge = (sources = {}) => {
    for (let i = 0; i < FAVICON_PRIORITY.length; i += 1) {
        const name = FAVICON_PRIORITY[i];
        const count = Number(sources[name]) || 0;
        if (count > 0) {
            return { count, color: SOURCE_COLOR[name] };
        }
    }
    return { count: 0, color: null };
};
